



import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  @Prop({ default: '' }) public source!: string;
  @Prop({ default: 'en' }) private lang!: string;
  @Prop({ default: false }) private interactive!: boolean;

  private beforeMount(): void {
    const lang = this.$el.attributes.getNamedItem('data-lang');
    const interactive = this.$el.attributes.getNamedItem('data-interactive');
    const source = this.$el.attributes.getNamedItem('data-source');
    if (lang != null) {
      this.lang = lang.value;
    }
    if (interactive != null) {
      this.interactive = interactive.value === 'true';
    }
    if (source != null) {
      this.source = source.value;
    }
  }

  private mounted(): void {
    if (this.$router.currentRoute.path === '/') {
      if (this.interactive) {
        if (this.$router.currentRoute.query.article !== undefined) {
          this.$router.replace({
            name: 'browse',
            query: {
              lang: this.lang,
              article: this.$router.currentRoute.query.article,
            },
          });
        } else if (this.$router.currentRoute.query.chapter !== undefined) {
          this.$router.replace({
            name: 'browse',
            query: {
              lang: this.lang,
              chapter: this.$router.currentRoute.query.chapter,
            },
          });
        } else {
          this.$router.replace({ name: 'browse', query: { lang: this.lang } });
        }
      } else {
        this.$router.replace({ name: 'expand', query: { lang: this.lang } });
      }
    }
  }
}
